import { Component, Vue, Watch, toNative } from 'vue-facing-decorator';
import template from './breadcrumb.html?raw';
import styles from './breadcrumb.module.scss';
import type { BreadCrumbModel } from '@/models/breadcrumb';
import type { RouteLocationMatched, RouteMeta } from 'vue-router';

@Component({
  template
})
class Breadcrumb extends Vue {
  styles = styles;

  isLoading = false;
  showBreadCrumb = false;

  baseBreadcrumb: BreadCrumbModel[] = [];
  breadcrumbs: BreadCrumbModel[] = [];

  get isHighlighted() {
    const { path } = this.$route;
    const dynamicallyHighlightedFromRouter = this.getRouteMeta()?.highlighted || false;
    const highlightedRoutes: string[] = [];

    return highlightedRoutes.includes(path.toLocaleLowerCase()) || dynamicallyHighlightedFromRouter;
  }

  async mounted() {
    this.appendDynamicBreadcrumbs();
  }

  appendDynamicBreadcrumbs() {
    const initialBreadCrumbs = [
      {
        external: true,
        text: this.$t('home') as string,
        href: '/',
      },
    ];

    this.breadcrumbs = [...initialBreadCrumbs];
    this.baseBreadcrumb = [...initialBreadCrumbs];

    this.updateBreadCrumbs();
  }

  @Watch('$route')
  updateBreadCrumbs() {
    this.showBreadCrumb = this.$route.fullPath !== '/';

    let enhancedBreadcrumbs: BreadCrumbModel[] = [...this.baseBreadcrumb];

    this.$route.matched.forEach((route: RouteLocationMatched) => {
      const enhancedMeta = this.getRouteMeta(route);

      const hasBreadcrumb = 'breadcrumb' in enhancedMeta;

      if (hasBreadcrumb) {
        enhancedBreadcrumbs = enhancedBreadcrumbs.concat(enhancedMeta.breadcrumb as BreadCrumbModel);
      } else {
        enhancedBreadcrumbs = [...this.baseBreadcrumb];
      }
    });

    // ? update [disabled/external] prop
    this.breadcrumbs = enhancedBreadcrumbs.map((route, index) => ({
      ...route,
      external: route.external || false,
      disabled: index === (enhancedBreadcrumbs.length - 1),
    }));
  }

  getRouteMeta(route: any = this.$route): RouteMeta {
    const { meta } = route;

    return typeof meta === 'function' ? meta(this.$route) : meta;
  }

  onClickBreadcrumb(route: BreadCrumbModel) {
    this.$router.push(route.href || '');
  }

}

export default toNative(Breadcrumb);